import * as activity from './activity'
import * as hotTopic from './hot-topic'
import * as news from './news'

export const sensorsCompany = { ...activity, ...hotTopic, ...news }
